function initButtonCharacterStagger() {
    const offsetIncrement = 0.01 // Transition offset increment in seconds
    const buttons = document.querySelectorAll('[data-button-animate-chars]')

    buttons.forEach((button) => {
        const text = button.textContent.trim() // Get the button's text content

        button.innerHTML = '' // Clear the original content
        ;[...text].forEach((char, index) => {
            const span = document.createElement('span')
            span.textContent = char
            span.style.transitionDelay = `${index * offsetIncrement}s`

            // Handle spaces explicitly
            if (char === ' ') {
                span.style.whiteSpace = 'pre' // Preserve space width
            }

            button.appendChild(span)
        })
    })
}

// Initialize Button Character Stagger Animation
document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 1024) {
        initButtonCharacterStagger()
    }
})
